/* eslint @typescript-eslint/no-explicit-any: 0 */
import axios, { CancelToken } from "axios";
import { AnyFilterTypes, OffersSearch, OfferType, PropertyTypes, ResultContent } from "Types";

const { host, protocol } = window.location;
let baseURL = `${protocol}//${host}${process.env.REACT_APP_API_PATH}`;
if (host.includes("localhost")) {
    baseURL = process.env.REACT_APP_API_PATH || "";
}
const api = axios.create({
    baseURL,
});

export const prepareParams = (params: AnyFilterTypes): { [key: string]: any } => {
    const result: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            result[key] = value
                .filter((item) => item !== null && item !== undefined)
                .map((item) => {
                    if (typeof item === "object") {
                        return item.id;
                    } else {
                        return item;
                    }
                });
        } else if (value !== "") {
            result[key] = value;
        }
    }

    // backend doesn't know offerType = 0 => all
    if (result.offerType === OfferType.all) {
        delete result.offerType;
    }
    if ("isOther" in result && result.typeOfProperties.length === 0) {
        return {
            ...result,
            typeOfProperties: [
                PropertyTypes.agricultureObjects,
                PropertyTypes.historicalObjects,
                PropertyTypes.recreationObjects,
                PropertyTypes.other,
            ],
        };
    }

    return result;
};

// api.defaults.headers.common['Content-Type'] = 'application/json';
export const searchOffers = async (params: AnyFilterTypes, cancelToken?: CancelToken): Promise<OffersSearch> => {
    const result = await api.post<OffersSearch>(
        "/search",
        prepareParams({ ...params, count: parseInt(process.env.REACT_APP_OFFERS_PER_PAGE ?? "") }),
        {
            cancelToken,
        }
    );
    return result.data;
};

export const searchOffersCount = async (params?: AnyFilterTypes | null): Promise<number> => {
    const parsedParams = params ? prepareParams(params) : null;
    if (parsedParams) {
        delete parsedParams.pageNumber;
    }
    const result = await api.post<number>("/search/count", parsedParams);
    return result.data;
};

export const searchContent = async (url: string, cancelToken?: CancelToken): Promise<ResultContent> => {
    const result = await api.get<ResultContent>("/search/content", {
        params: {
            url,
        },
        cancelToken,
    });
    return result.data;
};
